import z from "zod";

import { domainSchema } from "../../../../evidence/domain";

export const dataTablePreferencesBrowseSchema = domainSchema.extend({
  tableId: z.string(),
  name: z.string(),
  settings: z.string().nullish(),
});

export type DataTablePreferencesBrowseType = z.infer<
  typeof dataTablePreferencesBrowseSchema
>;
